import { BaseDto } from '../base.dto';

export class MembershipTypeDto extends BaseDto {
  name: string;
  photoUrl: string;
  description: string;
  active: boolean;
  brandId: number;
  merchants: any;
  merchantIds: any[];
  merchantId?: number;
  merchant: any;
  discountTypeId?: number;
}
